import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { apiClientesInstance, authHeaderClientes } from "../../redux/actions/clientes/clientes";

import { Form, Input, Button, Row, Col, Typography, Space } from "antd";
import { toast } from "../../components/toasts/toastStore";

import "./EventosPage.css";
import "./PaquetesPage.css";

const { Title, Text } = Typography;

export default function CrearClientePage() {
  const navigate = useNavigate();
  const { idCliente } = useParams();
  const isEditing = !!idCliente;

  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!isEditing) return;
    apiClientesInstance.get(`/clientes/${idCliente}`, { headers: authHeaderClientes() })
      .then((res) => {
        const c = res.data ?? {};
        form.setFieldsValue({
          nombre: c.nombre,
          telefono: c.telefono,
          rfc: c.rfc,
          razon_social: c.razon_social,
          codigo_postal_fiscal: c.codigo_postal_fiscal,
          regimen_fiscal: c.regimen_fiscal,
          uso_cfdi: c.uso_cfdi,
        });
      })
      .catch(() => toast.error("No se pudo cargar el cliente"));
  }, [idCliente]);

  const handleSave = async () => {
    let values;
    try {
      values = await form.validateFields();
    } catch {
      return;
    }

    const payload = {
      nombre: values.nombre?.trim(),
      telefono: values.telefono?.trim() || null,
      rfc: values.rfc?.trim() || null,
      razon_social: values.razon_social?.trim() || null,
      codigo_postal_fiscal: values.codigo_postal_fiscal?.trim() || null,
      regimen_fiscal: values.regimen_fiscal?.trim() || null,
      uso_cfdi: values.uso_cfdi?.trim() || null,
    };

    setSaving(true);
    try {
      if (isEditing) {
        await apiClientesInstance.patch(`/clientes/${idCliente}`, payload, { headers: authHeaderClientes() });
        toast.success("Cliente actualizado correctamente");
      } else {
        await apiClientesInstance.post("/clientes", payload, { headers: authHeaderClientes() });
        toast.success("Cliente creado exitosamente");
      }
      navigate("/app/clientes");
    } catch (err) {
      toast.error(err?.response?.data?.detail || err.message || "Error al guardar");
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="paq-main">
      <div className="paq-content">
        <section className="cc-page-header-card">
          <Space direction="vertical" size={2}>
            <Title level={2} className="eventos-title" style={{ marginBottom: 0 }}>
              {isEditing ? "Editando cliente" : "Nuevo cliente"}
            </Title>
            <Text className="eventos-subtitle">
              {isEditing
                ? "Modifica los datos del cliente y guarda los cambios."
                : "Completa los datos del cliente para registrarlo en el sistema."}
            </Text>
          </Space>

          <Space>
            <Button className="eventos-btn-clean" onClick={() => navigate("/app/clientes")} disabled={saving}>
              Cancelar
            </Button>
            <Button
              type="primary"
              loading={saving}
              icon={!isEditing ? <i className="fa-solid fa-plus" /> : null}
              onClick={handleSave}
              style={{ backgroundColor: "#f90336", borderColor: "#f90336" }}
            >
              {isEditing ? "Guardar cambios" : "Crear cliente"}
            </Button>
          </Space>
        </section>

        <Form form={form} layout="vertical">
          <div className="cc-section-card">
            <div className="cc-section-header">
              <span className="cc-section-icon"><i className="fa-solid fa-address-book"></i></span>
              Datos del cliente
            </div>

            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="nombre"
                  label={<span className="paq-field-label">Nombre del cliente</span>}
                  rules={[{ required: true, message: "Requerido" }]}
                >
                  <Input placeholder="Ej. Juan Perez" autoComplete="off" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="telefono" label={<span className="paq-field-label">Telefono</span>}>
                  <Input placeholder="Telefono de contacto" autoComplete="off" />
                </Form.Item>
              </Col>
            </Row>
          </div>

          <div className="cc-section-card" style={{ marginTop: 20 }}>
            <div className="cc-section-header">
              <span className="cc-section-icon"><i className="fa-solid fa-file-invoice"></i></span>
              Datos fiscales (opcional)
            </div>
            <Text style={{ fontSize: 12, color: "#64748b", display: "block", marginBottom: 14 }}>
              Solo necesarios si el cliente va a pedir factura.
            </Text>

            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item name="razon_social" label={<span className="paq-field-label">Razon social</span>}>
                  <Input placeholder="Razon social para factura" autoComplete="off" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="rfc" label={<span className="paq-field-label">RFC</span>}>
                  <Input placeholder="RFC del cliente" autoComplete="off" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} md={8}>
                <Form.Item name="codigo_postal_fiscal" label={<span className="paq-field-label">Codigo postal fiscal</span>}>
                  <Input placeholder="C.P." autoComplete="off" />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item name="regimen_fiscal" label={<span className="paq-field-label">Regimen fiscal</span>}>
                  <Input placeholder="Ej. 612 - Personas Fisicas" autoComplete="off" />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item name="uso_cfdi" label={<span className="paq-field-label">Uso de CFDI</span>}>
                  <Input placeholder="Ej. G03 - Gastos en general" autoComplete="off" />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
      </div>
    </main>
  );
}
